import React, { useEffect, useState } from 'react';
import api from '../services/api';

const card = { background:'#111616', border:'1px solid #26333a', borderRadius:12, padding:14, marginBottom:14 };
const naira = n => '₦' + Number(n || 0).toLocaleString('en-NG');
const date = d => d ? new Date(d).toLocaleString('en-NG', { dateStyle:'medium', timeStyle:'short' }) : '—';

export default function LeaderboardRewardsPanel() {
  const [data,setData]=useState(null);
  const [error,setError]=useState('');
  const [loading,setLoading]=useState(true);
  useEffect(()=>{let active=true;api.get('/leaderboard-rewards').then(r=>{if(active)setData(r.data?.data||null);}).catch(e=>{if(active)setError(e.response?.status===401?'Sign in to view your leaderboard points and reward status.':'Leaderboard rewards are temporarily unavailable.');}).finally(()=>{if(active)setLoading(false);});return()=>{active=false;};},[]);
  if(loading)return <section style={card}>Loading weekly and monthly rewards…</section>;
  if(error)return <section style={{...card,color:'#aab4ba'}} aria-live="polite">{error}</section>;
  if(!data)return null;
  return <section style={card} aria-label="WHOT leaderboard rewards">
    <h2 style={{margin:'0 0 6px',fontSize:18,color:'#00d4aa'}}>🏆 WHOT Leaderboard Rewards</h2>
    <p style={{margin:'0 0 12px',fontSize:12,color:'#9aa3ab'}}>Weekly top 5 · Monthly top 3 · Rewards are held for 48 hours after a period closes.</p>
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(240px,1fr))',gap:10}}>
      {['weekly','monthly'].map(board=>{
        const b=data[board]||{};
        return <div key={board} style={{border:'1px solid #26333a',borderRadius:10,padding:12}}>
          <h3 style={{margin:'0 0 8px',textTransform:'capitalize'}}>{board} leaderboard</h3>
          {!b.enabled?<p style={{color:'#9aa3ab',fontSize:13}}>This board is not currently enabled.</p>:<>
            <p style={{fontSize:12,color:'#9aa3ab'}}>Closes: {date(b.closesAt)}</p>
            <div style={{display:'flex',gap:12,flexWrap:'wrap',fontSize:13,marginBottom:8}}>
              <span>Your points: <b>{b.yourStats?.points ?? 0}</b></span>
              <span>Games: <b>{b.yourStats?.games_counted ?? 0}</b></span>
              <span>Rank: <b>{b.yourStats?.rank ?? '—'}</b></span>
            </div>
            {!b.yourStats?.eligible&&<p style={{fontSize:12,color:'#9aa3ab'}}>Qualification: {b.yourStats?.qualification_reason || 'requirements not yet met'}</p>}
            <ol style={{paddingLeft:22,margin:'8px 0'}}>
              {(b.standings||[]).map((x,i)=><li key={x.username+'-'+i} style={{padding:'3px 0',fontSize:13}}>{x.username} — {x.points} pts</li>)}
              {!b.standings?.length&&<li style={{fontSize:12,color:'#9aa3ab'}}>No qualified standings yet.</li>}
            </ol>
            <div style={{borderTop:'1px solid #26333a',paddingTop:8,marginTop:8}}>
              <b style={{fontSize:12}}>Prize table {b.poolAmount ? '(current pool ₦'+Number(b.poolAmount).toLocaleString('en-NG')+')' : '(no pool available yet)'}</b>
              {(b.prizeTable||[]).length ? <ol style={{paddingLeft:22,margin:'6px 0'}}>{b.prizeTable.map(p=><li key={p.rank} style={{fontSize:12,margin:'3px 0'}}>Rank #{p.rank}: {naira(p.amount)}</li>)}</ol> : <p style={{fontSize:12,color:'#9aa3ab'}}>No payout: the pool is zero or first-place minimum is not met.</p>}
            </div>
            {(b.pendingRewards||[]).length>0&&<div style={{borderTop:'1px solid #26333a',paddingTop:8,marginTop:8}}>
              <b style={{fontSize:12}}>Your rewards</b>
              {b.pendingRewards.map((r,i)=><p key={r.rank+'-'+i} style={{margin:'5px 0',fontSize:12}}>{naira(r.amount)} · Rank #{r.rank} · {String(r.status).replace(/_/g,' ')} · hold until {date(r.hold_until)}</p>)}
            </div>}
          </>}
        </div>;
      })}
    </div>
  </section>;
}
